__turbopack_context__.v({
  "animated-gradient-text": "index-module-scss-module__OZXxSG__animated-gradient-text",
  "ant-dropdown-menu": "index-module-scss-module__OZXxSG__ant-dropdown-menu",
  "ant-dropdown-menu-item": "index-module-scss-module__OZXxSG__ant-dropdown-menu-item",
  "ant-dropdown-menu-item-selected": "index-module-scss-module__OZXxSG__ant-dropdown-menu-item-selected",
  "ant-dropdown-menu-title-content": "index-module-scss-module__OZXxSG__ant-dropdown-menu-title-content",
  "back-top-wrap": "index-module-scss-module__OZXxSG__back-top-wrap",
  "filterTableSelect": "index-module-scss-module__OZXxSG__filterTableSelect",
  "gradient-overlay": "index-module-scss-module__OZXxSG__gradient-overlay",
  "gradient-text-horizontal": "index-module-scss-module__OZXxSG__gradient-text-horizontal",
  "gradient-text-vertical": "index-module-scss-module__OZXxSG__gradient-text-vertical",
  "pause-on-hover": "index-module-scss-module__OZXxSG__pause-on-hover",
  "text-content": "index-module-scss-module__OZXxSG__text-content",
  "vertical": "index-module-scss-module__OZXxSG__vertical",
  "with-border": "index-module-scss-module__OZXxSG__with-border",
});
